import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UserQrGeneratorModelComponent } from '../user-qr-generator-model/user-qr-generator-model.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../core/api.service';
import { UtilityService } from '../../../core/global/utility.service';
import { FunctionsService } from '../../../core/global/functions.service';
import { Location } from '@angular/common'
@Component({
  selector: 'app-user-landing-page',
  templateUrl: './user-landing-page.component.html',
  styleUrls: ['./user-landing-page.component.sass']
})
export class UserLandingPageComponent {
  userDetails: any = {};
  userDetails2: any = {};
  userDetails3: any = {};
  deleteID = '';
  modalConfirmation;
  searchInput: any = '';
  sortedtby: any = 'date';
  sorttype: any = 'asc'
  page: number = 1; // Enter 1 if you want to use the server side pagination
  p;
  limit = 10
  count: any
  last: any
  salt = 'Momentum2021'
  userType: string;
  id = ''
  name = ''
  totalPages = [];
  user_name: string
  length: number
  is_dining_active: boolean = false
  is_speaker_active: boolean = false
  is_about_active: boolean = false
  is_agenda_active: boolean = false
  constructor(private location: Location, private modalService: NgbModal, private route: ActivatedRoute, private router: Router, private _adminService: ApiService, private _utility: UtilityService, private _function: FunctionsService) { }
  async ngOnInit(): Promise<void> {
    var elem = document.getElementById('html').classList
    elem.add('bg')
    this.id = this.route.snapshot.paramMap.get('id');
    await this.getUserName();
    await this.getUserLog();
  }
  back() {
    this.is_dining_active = false
    this.is_speaker_active = false
    this.is_about_active = false
    this.is_agenda_active = false
    var elem = document.getElementById('html').classList
    elem.remove('bg-2')
  }
  async getUserLog() {
    let wheredata = []
    wheredata = [{ 'field': '`qr_user_role`.`user_id`', 'value': this.id, 'type': 'WHERE', 'nested': '' }]
    let data = { whereData: wheredata, searchText: this.searchInput, sorttype: this.sorttype, sortby: this.sortedtby, page: this.page };
    let url = "users/user_role_list";
    this._utility.showLoader();
    this._adminService.login(url, data).subscribe((response) => {
      this._utility.hideLoader();
      if (response.status == 200) {
        if (response.data.length > 0) {
          if (response.data[0]!= undefined ) {
            this.userDetails = response.data[0];
          }
          if (response.data[1]!= undefined ) {
            this.userDetails2 = response.data[1];
          }
          if (response.data[2] != undefined) {
            this.userDetails3 = response.data[2];
          }
        } else {
          this.length = response.data.length
        }
      } else {
        this._utility.toastError(response.message);
      }
    })
  }

  async getUserName() {
    let wheredata = []
    wheredata = [{ 'field': '`qr_user`.`id`', 'value': this.id, 'type': 'WHERE', 'nested': '' }]
    let data = { whereData: wheredata, searchText: this.searchInput, sorttype: this.sorttype, sortby: 'id', page: this.page };
    let url = "users/user_list";
    this._utility.showLoader();
    this._adminService.login(url, data).subscribe((response) => {
      this._utility.hideLoader();
      if (response.status == 200) {
        if (response.data.length>0) {
          this.user_name = response.data[0].user_name
        }else{
          this.user_name=''
        }
      } else {
        this._utility.toastError(response.message);
      }
    })
  }
  getContent(type) {
    if (type == 1) {
      this.is_dining_active = false
      this.is_speaker_active = true
      var elem = document.getElementById('html').classList
      elem.add('bg-2')
      this.is_about_active = true
      this.is_agenda_active = true
    }
    if (type == 2) {
      var elem = document.getElementById('html').classList
      elem.add('bg-2')
      this.is_dining_active = true
      this.is_speaker_active = false
      this.is_about_active = true
      this.is_agenda_active = true
    }
    this.getUserLog()
  }
  scroll(id: string) {
    const element = document.getElementById(id);
    element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }
}
